import axiosService from './axiosService';
import config from '../config';
export const handleLoginAPI = (email, password) => {
    return axiosService.post(`${config.REACT_SERVER_CONNECT_URL}/auth/login`, email, password);
}
